import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { getCleanedUrlParams, showError } from '@utils';
import { teamsServices } from '@services';
import { FILTER_RULE_ENUMS } from '@constants';
import { QUERY_KEYS } from 'constants/queryKeys';

export const TEAMS_PAGE_SIZE = 3000;
export const TEAMS_ORDER_BY = 'name';
export const TEAMS_ORDER = 'asc';

export const normalizeTeams = (data) => {
  if (!data?.length) {
    return [];
  }

  return data
    .map((item) => ({
      value: item?.id || '-',
      label: item?.name || '-',
      text: item?.name || '-',
      active: item?.active || false,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const useTeams = (enabled = true) => {
  const page = 1;
  const pageSize = TEAMS_PAGE_SIZE;
  const orderBy = TEAMS_ORDER_BY;
  const order = TEAMS_ORDER;

  const params = {
    orderBy,
    order,
    page,
    pageSize,
  };

  const teamsResponse = useQuery(
    [QUERY_KEYS.GET_TICKET_CREATION_TEAMS_KEY, params],
    () =>
      teamsServices.getTeams(getCleanedUrlParams(params), {
        type: FILTER_RULE_ENUMS.EmptyRuleType,
      }),
    { enabled }
  );

  const teams = normalizeTeams(teamsResponse?.data?.data || []);
  const activeTeams = teams.filter((team) => team.active);

  useEffect(() => {
    if (teamsResponse.isError) {
      showError(teamsResponse?.error);
    }
  }, [teamsResponse.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    teams,
    activeTeams,
    isFetched: teamsResponse.isFetched,
    isLoading: teamsResponse.isLoading,
  };
};
